import InputNumber, { InputNumberProps } from 'antd/lib/input-number';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';

export const AndroidStagedRolloutPercentageInput: React.FC<InputNumberProps> = (props) => (
    <InputNumber
        max={100}
        min={0}
        step={1}
        // this seems to be the maximum precision for Google Play staged rollouts.
        // For example, trying to set a rollout to 10.00000039% will lose precision and return 10.0000004% when fetching track data.
        precision={7}
        addonAfter={<Text style={{ fontSize: 16 }}>%</Text>}
        {...props}
    />
);
